import * as React from 'react'
import ProjectsCard from './ProjectsCard'

// Function to capitalize the first letter of each word
function capitalLetter (str) {
  // All of my repo name's are split with a hyphen
  str = str.split('-')

  for (var i = 0, x = str.length; i < x; i++) {
    str[i] = String(str[i][0].toUpperCase()) + String(str[i].substr(1))
  }
  // Re-construct the name with spaces instead of a hyphen
  return str.join(' ')
}

interface ReposProps {
  repos: any
}

const Repos: React.ElementType = (props: ReposProps) => {
  const { repos } = props

  return repos.map(repo => <ProjectsCard language={repo.language} title={capitalLetter(repo.name)} about={repo.description} link={repo.html_url} key={repo.name}/>)
}

export default Repos
